var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPen(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 13,
    viewBox: "0 0 12 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.661885 9.0974C0.607652 9.15163 0.571166 9.22063 0.555691 9.29502L0.00754647 12.0367C-0.0180081 12.1638 0.0223113 12.2948 0.11374 12.3871C0.187422 12.4608 0.286659 12.5003 0.388309 12.5003C0.413012 12.5003 0.438708 12.498 0.464263 12.4926L3.20513 11.9445C3.28108 11.9288 3.35008 11.8925 3.4036 11.8381L9.53811 5.70361L6.79725 2.96289L0.661885 9.0974Z",
    fill: "#31435B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4311 1.06699C10.6752 0.311003 9.44547 0.311003 8.69019 1.06699L7.61719 2.14L10.3581 4.88086L11.4311 3.80772C11.7971 3.44257 11.9987 2.95561 11.9987 2.43771C11.9987 1.9198 11.7971 1.43285 11.4311 1.06699Z",
    fill: "#31435B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPen);
export default __webpack_public_path__ + "static/media/pen.9c9100acc073b907fab17afddc20d6b7.svg";
export { ForwardRef as ReactComponent };